import {
  REACT_APP_TRANSACTION_HISTORY_BASE_URL,
  REACT_APP_CREDIT_BASE_URL,
  REACT_APP_SIGNUP_LOCALITY,
  REACT_APP_MESSAGES_HISTORY_BASE_URL,
  REACT_APP_LINK_FBM_BASE_URL,
  REACT_APP_PAYMENTS_BASE_URL,
} from "config";

const APOLLO_LINK_BASE_URLS = {
  transactionHistory: REACT_APP_TRANSACTION_HISTORY_BASE_URL,
  credit: REACT_APP_CREDIT_BASE_URL,
  signUp: REACT_APP_SIGNUP_LOCALITY,
  appInbox: REACT_APP_MESSAGES_HISTORY_BASE_URL,
  linkFbm: REACT_APP_LINK_FBM_BASE_URL,
  payments: REACT_APP_PAYMENTS_BASE_URL,
};

export { APOLLO_LINK_BASE_URLS };
